export default {
  // 导入
  IMPORT_HISTORY: '/maindata/partnersPaymentHistory/importPaymentHistory',
  // 分页查询
  QUERY_DATA: '/maindata/partnersPaymentHistory/page',
};
